import { styled } from '@mui/material';

const ReportInfoBlockGrid = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	gap: '16px',
}));

export default ReportInfoBlockGrid;
